module.exports = __webpack_public_path__ + "platform-web/static/media/chevron-left.e97c17b1.svg";